<template>
  <div class="assignees">
    <b-dropdown
      v-if="isFilterDropdown || canAssignEvaluator"
      no-caret
      :right="!isFilterDropdown && !showTextButton"
      :class="`assignees__dropdown ${
        !isFilterDropdown && assignedEvaluators.length > 0 && 'assigned'
      } ${isFilterDropdown && 'filter'} ${showTextButton && 'big-button'}`"
      :style="{
        zIndex:
          !isFilterDropdown &&
          assignedEvaluators.length > 0 &&
          assignedEvaluators.length + 1,
      }"
      @shown="handleGtmEvent"
    >
      <template #button-content>
        <template v-if="isFilterDropdown">
          <div class="d-flex align-items-center">
            <span>{{ resource["assignessSelectText"] }}</span>
            <span
              class="assignees__evaluator-count"
              v-if="assignedEvaluators.length"
              >{{ assignedEvaluators.length }}</span
            >
          </div>
          <i class="icon-down-arrow"></i>
        </template>
        <template v-else-if="showTextButton">
          <span v-if="assignedEvaluators.length === 0"
            >{{ resource["AssignAnEvaluatorText"] }}</span
          >
          <i class="icon-add"></i>
        </template>
        <template v-else-if="!showTextButton">
            <div
                class="d-flex align-items-center justify-content-center"
                v-b-tooltip.hover.bottom="{ customClass: 'assignees-tooltip', disabled: assignedEvaluators.length > 0 }"
                :title="resource['AssignOneBtnTooltip']"
            >
                <i class="icon-add"></i>
            </div>
        </template>
      </template>
      <div class="dropdown-search">
        <b-form-input
          v-model="searchQuery"
          placeholder="Search"
          class="dropdown-search-input"
          @click="
            ($event) => {
              $event?.stopPropagation();
              $event?.preventDefault();
            }
          "
        >
        </b-form-input>
        <i class="icon-search-big-line"></i>
      </div>
      <div class="dropdown-content">
        <template v-if="isUserListLoading">
          <div class="assignees__no-result">{{resource['AssignLoadingUserText']}}</div>
        </template>
        <template v-if="filteredUserList.length === 0">
          <div class="assignees__no-result" v-if="searchQuery.length > 0">{{resource['AssignSearchNoResult']}}</div>
          <div class="assignees__no-result" v-else>{{resource['AssignUsersNoItem']}}</div>
        </template>
        <template v-else>
          <b-dropdown-item
            v-if="isFilterDropdown"
            @click="handleItemClick($event, unassignedUser)"
          >
            <b-form-checkbox
              class="checkbox-candidate d-flex align-items-center cursor-pointer"
              :id="`checkbox-unassigned`"
              :checked="assignedEvaluators.some((evaluator) => evaluator === -1)"
              @change="addUserToGroup(isFilterDropdown ? null : $event, unassignedUser)"
              @click.native.stop
            >
              {{ unassignedUser?.name }}
            </b-form-checkbox>
          </b-dropdown-item>
          <b-dropdown-item
            v-for="user in filteredUserList"
            :key="user.id"
            @click="handleItemClick($event, user)"
          >
            <b-form-checkbox
              v-if="isFilterDropdown"
              class="checkbox-candidate d-flex align-items-center cursor-pointer"
              :id="`checkbox-${user.id}`"
              :checked="assignedEvaluators.some((evaluator) => evaluator === user.id)"
              @change="addUserToGroup(isFilterDropdown ? null : $event, user)"
              @click.native.stop
            >
              <template v-if="currentUser.userId === user.id">
                {{ user.name }} {{ user.surname }} ({{ resource["meText"] }})
              </template>
              <template v-else>
                {{ user.name }} {{ user.surname }}
              </template>
            </b-form-checkbox>
            <template v-else>
              <span
                v-if="currentUser.userId === user.id"
              >
                {{ user.name }} {{ user.surname }} ({{ resource["meText"] }})
              </span>
              <span v-else>
                {{ user.name }} {{ user.surname }}
              </span>
            </template>
          </b-dropdown-item>
        </template>
      </div>
    </b-dropdown>
    <template
      v-if="
        !isFilterDropdown &&
        assignedEvaluators.length &&
        assignedEvaluators.length > 0
      "
    >
      <div
        v-for="(evaluator, index) in assignedEvaluators.slice(0, 4)"
        :key="evaluator.id"
        class="assignees__evaluator"
        :style="{
          backgroundColor: evaluator.color || randomColorPalette[index % randomColorPalette.length],
          zIndex: assignedEvaluators.length - index,
        }"
        v-b-tooltip.hover.bottom="{ customClass: 'assignees-tooltip' }"
        :title="`${evaluator.name} ${evaluator.surname}`"
        :id="`assignees__evaluator-${evaluator.id}`"
        @click="
          (e) => {
            e.stopPropagation();
            e.preventDefault();
          }
        "
      >
        {{ getInitials(evaluator) }}
        <i
          v-if="canAssignEvaluator"
          class="icon-close"
          @click="removeUserFromGroup($event, evaluator)"
        ></i>
      </div>
      <div
        v-show="assignedEvaluators.length > 4"
        class="show-more-button"
        :id="`show-more-tooltip-${_uid}`"
        :style="{
          zIndex: assignedEvaluators.length - 4,
        }"
      >
        +{{ assignedEvaluators.length - 4 }}
      </div>
      <b-tooltip
        :id="`show-more-tooltip-${_uid}`"
        :target="`show-more-tooltip-${_uid}`"
        triggers="hover"
        placement="bottom"
        custom-class="assignees-tooltip cursor-pointer"
        boundary="viewport"
      >
        <div class="assignees__tooltip-content">
          <div
            v-for="evaluator in assignedEvaluators.slice(4)"
            :key="evaluator.id"
          >
            {{ evaluator.name }} {{ evaluator.surname }}
            <i
              v-if="canAssignEvaluator"
              class="icon-close"
              @click="removeUserFromGroup($event, evaluator)"
            ></i>
          </div>
        </div>
      </b-tooltip>
    </template>
  </div>
</template>
<script>
import { mapActions, mapState } from 'vuex';

export default {
  name: 'Assignees',
  props: {
    assignedEvaluators: {
      type: Array,
      default: () => [],
    },
    isFilterDropdown: {
      type: Boolean,
      default: false,
    },
    showTextButton: {
      type: Boolean,
      default: true,
    },
    canAssignEvaluator: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      searchQuery: '',
      colorPalette: ['#FFEBCF', '#F8DADA', '#DBF0F9', '#DBF4E4', '#FFF6DA'],
      unassignedUser: null,
    };
  },
  async created() {
    await this.fetchUserList();
    this.unassignedUser = {
      id: -1,
      name: this.resource.unassignedText,
      surname: '',
    };
  },
  computed: {
    ...mapState('utils', {
      userList: (state) => state.userList,
      isUserListLoading: (state) => state.isLoading,
    }),
    filteredUserList() {
      let list = this.userList;
      if (!this.isFilterDropdown) {
        const assignedIds = new Set(
          this.assignedEvaluators.map((e) => e.id),
        );
        list = this.userList.filter((user) => !assignedIds.has(user.id));
      }
      // move current user to the top of the list
      const currentUser = list.find((user) => user.id === this.currentUser.userId);
      if (currentUser) {
        list = [currentUser, ...list.filter((user) => user.id !== this.currentUser.userId)];
      }

      return list.filter((user) => `${user.name} ${user.surname}`
        .toLowerCase()
        .includes(this.searchQuery.toLowerCase()));
    },
    randomColorPalette() {
      const arr = [...this.colorPalette];
      for (let i = arr.length - 1; i > 0; i -= 1) {
        const j = Math.floor(Math.random() * (i + 1));
        [arr[i], arr[j]] = [arr[j], arr[i]];
      }
      return arr;
    },
  },
  methods: {
    ...mapActions('utils', ['fetchUserList']),
    getInitials(evaluator) {
      const nameInitial = evaluator.name
        ? evaluator.name.charAt(0).toUpperCase()
        : '';
      const surnameInitial = evaluator.surname
        ? evaluator.surname.charAt(0).toUpperCase()
        : '';
      return `${nameInitial}${surnameInitial}`;
    },
    handleItemClick(event, user) {
      if (this.isFilterDropdown) {
        event?.stopPropagation();
        event?.preventDefault();
      } else {
        this.addUserToGroup(event, user);
      }
    },
    addUserToGroup(event, user) {
      event?.stopPropagation();
      event?.preventDefault();
      const colorIndex = this.assignedEvaluators.length % this.colorPalette.length;
      const userWithColor = { ...user, color: this.colorPalette[colorIndex] };
      this.$emit('addUser', userWithColor);
      this.searchQuery = '';
    },
    removeUserFromGroup(event, user) {
      event?.stopPropagation();
      event?.preventDefault();
      this.$emit('removeUser', user);
    },
    handleGtmEvent() {
      dataLayer.push({
        event: 'ga4_event',
        event_name: 'button_click',
        page_type: 'interview-detail',
        site_type: 'interview',
        event_parameters: {
          button_name: 'assignees-plus-icon',
        },
      });
    },
  },
};
</script>
<style lang="scss" scoped>
@import "~@/style/starter.scss";

.list-enter-active, .list-leave-active {
  transition: all 0.2s;
}
.list-enter, .list-leave-to {
  opacity: 0;
  transform: translateY(10px);
}

.assignees {
  display: flex;
  align-items: center;

  &__evaluator {
    width: 32px;
    height: 32px;
    padding: 0px;
    margin-left: -5px;
    display: flex;
    align-items: center;
    justify-content: center;
    text-align: center;
    border-radius: 96px;
    border: 2px solid #fff;
    background-color: #ffebcf; /* Arka plan rengi */
    color: #333333;
    font-size: 12px;
    font-weight: 500;
    line-height: 18px;
    font-family: Roboto;
    text-transform: uppercase;
    position: relative;

    &:first-child {
      margin-left: 0;
    }

    &:hover {
      i {
        visibility: visible;
      }
    }

    i {
      visibility: hidden;
      position: absolute;
      right: -6px;
      top: -12px;
      width: 20px;
      height: 20px;
      padding: 2px;
      margin: 0px;
      display: flex;
      justify-content: center;
      align-items: center;
      border-radius: 512px;
      border: 1px solid #e5e5e5;
      background-color: #fff;
      color: #333333 !important;
      font-size: 14px !important;

      &:hover {
        background: #FAFAFA;
        border-color: #D4D4D4;
      }
    }
  }

  &__evaluator-count {
    display: flex;
    height: 16px;
    padding: 0px 5px;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    gap: 10px;
    border-radius: 50px;
    background: #333;
    margin-left: 2px;
    color: #fff;
    text-align: center;
    font-family: Roboto;
    font-size: 10px;
    font-style: normal;
    font-weight: 400;
    line-height: 11px;
  }

  &__no-result {
    display: flex;
    padding: 6px 0px;
    gap: 8px;
    background: #fff;
    color: #333333;
    font-family: Roboto;
    font-size: 12px;
    font-style: normal;
    font-weight: 400;
    line-height: 16px !important;
  }
}

::v-deep {
  .assignees__dropdown {
    &:hover {
      .dropdown-toggle {
        background: #eeeeee !important;
      }
    }
    .dropdown-menu {
      width: 256px !important;
      max-height: 226px;
      border-radius: 4px;
      border: 1px solid#E5E5E5;
      background: #fff;
      color: #333333;
      box-shadow: 0px 2px 12px 1px rgba(0, 0, 0, 0.12);
      padding: 4px 0px !important;
      left: 0 !important;

      &::-webkit-scrollbar {
        width: 7px !important;
      }

      &::-webkit-scrollbar-track {
        background-color: #fff !important;
        border-radius: 2px !important;
      }

      &::-webkit-scrollbar-thumb {
        border-radius: 2px !important;
        background: linear-gradient(to right, #d8d8d8 3px, #fff 4px) !important;
      }
    }

    .dropdown-content {
      max-height: 168px;
      overflow-y: auto;
      padding-left: 8px;

      &::-webkit-scrollbar {
        width: 7px !important;
      }

      &::-webkit-scrollbar-track {
        background-color: #fff !important;
        border-radius: 2px !important;
      }

      &::-webkit-scrollbar-thumb {
        border-radius: 2px !important;
        background: linear-gradient(to right, #d8d8d8 3px, #fff 4px) !important;
      }
    }

    .dropdown-search {
      width: 100%;
      padding: 6px 8px;
      box-sizing: border-box;
      position: relative;

      .dropdown-search-input {
        width: 100%;
        padding-right: 27px !important;
        box-sizing: border-box;
      }

      i {
        position: absolute;
        right: 16px;
        font-size: 18px;
        color: #333333;
        cursor: pointer;
        z-index: 1;
        top: 16px;
      }
    }

    .dropdown-item {
      display: flex;
      height: 30px;
      width: 100% !important;
      padding: 6px 8px !important;
      align-items: center;
      gap: 8px;
      flex-shrink: 0;
      align-self: stretch;
      border-radius: 2px;
      background: #fff;
      color: #333 !important;
      font-feature-settings: "liga" off, "clig" off;
      font-family: Roboto;
      font-size: 14px;
      font-style: normal;
      font-weight: 400;
      line-height: 20px !important;
      box-sizing: border-box;

      &:hover {
        color: #000;
        border-radius: 2px;
        background: #e5e5e5;
        width: 100% !important;
      }
    }

    &.show {
      .dropdown-toggle {
        background: #eeeeee !important;
      }
    }

    .dropdown-toggle {
      display: flex;
      justify-content: center !important;
      align-items: center !important;
      background: #fff;
      border: 1px solid #d4d4d4;
      border-radius: 96px;
      width: 28px;
      height: 28px;
      padding: 0px;
      gap: 0px;

      i {
        font-size: 14px;
        color: #333333;
        margin-right: 0 !important;
      }
    }

    &.big-button {
      .dropdown-toggle {
        width: auto;
        padding: 6px 8px;
        gap: 8px;
        outline: 0px !important;
        height: 32px;
      }
    }

    &.assigned {
      &.show {
        .dropdown-toggle {
          background: #eeeeee !important;
        }
      }
      .dropdown-toggle {
        display: flex;
        justify-content: center;
        align-items: center;
        background: #fff !important;
        border: 1px solid #d4d4d4 !important;
        outline: 2px solid #fff !important;
        border-radius: 96px;
        width: 28px;
        height: 28px;
        padding: 0px;
        gap: 0px;

        i {
          font-size: 14px;
          color: #333333;
          margin-right: 0;
        }
        &:hover {
          background: #eeeeee !important;
        }
      }
    }

    &.filter {
      .dropdown-item {
        &:hover {
          background: transparent !important;
        }
      }
      &.show {
        .dropdown-toggle {
          background: #eeeeee !important;
        }
      }
      .dropdown-toggle {
        width: 118px;
        height: 32px;
        padding: 6px 12px;
        justify-content: space-between !important;
        align-items: center;
        border-radius: 50px;
        border: 1px solid #d4d4d4 !important;
        background: #fff !important;
        color: var(--Text-Colors-Primary-Gray-Text, #333);
        font-feature-settings: "liga" off, "clig" off;
        /* Typography/Small Text/1 - Medium */
        font-family: Roboto;
        font-size: 12px;
        font-style: normal;
        font-weight: 500;
        line-height: 18px;

        i {
          font-size: 12px;
          color: #333333;
          margin-right: 0;
          font-weight: normal;
        }
      }
    }
  }
  .checkbox-candidate {
    .custom-control-label {
      cursor: pointer;
      color: #333 !important;
      font-feature-settings: "liga" off, "clig" off;
      font-family: Roboto;
      font-size: 14px;
      font-style: normal;
      font-weight: 400;
      line-height: 20px !important;
      padding: 2px !important;

      &:hover {
        &::after {
          background: #ffe9ce;
        }
      }
      &::after {
        border: 1px solid #333;
        border-radius: 2px;
      }
      &::before {
        border-color: transparent !important;
        outline: none;
        box-shadow: none;
        width: 16px !important;
        height: 16px !important;
      }
    }
    .custom-control-input {
      cursor: pointer;
      &:focus {
        border-color: transparent !important;
      }
      &:checked {
        & ~ .custom-control-label {
          &::before {
            content: url('data:image/svg+xml,<svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none"><path d="M5.86337 10.5836L3.55004 8.27026C3.29004 8.01026 2.87004 8.01026 2.61004 8.27026C2.35004 8.53026 2.35004 8.95026 2.61004 9.21026L5.39671 11.9969C5.65671 12.2569 6.07671 12.2569 6.33671 11.9969L13.39 4.94359C13.65 4.68359 13.65 4.26359 13.39 4.00359C13.13 3.74359 12.71 3.74359 12.45 4.00359L5.86337 10.5836Z" fill="white"/></svg>') !important;
            color: $white !important;
            background: $purple !important;
            font-size: 14px;
            text-align: center;
            position: absolute;
            left: -25px;
            border-radius: 2px;
          }
          &::after {
            display: none !important;
          }
        }
      }
    }
  }

  .assignees__tooltip-content {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    gap: 4px;

    div {
        width: 100%;
        display: flex;
        justify-content: space-between;
        align-items: center;
        gap: 4px;
        color: #333;
        font-feature-settings: 'liga' off, 'clig' off;
        /* Typography/Small Text/1 - Regular */
        font-family: Roboto;
        font-size: 12px;
        font-style: normal;
        font-weight: 400;
        line-height: 18px;

        i {
            font-size: 12px !important;
        }
    }
  }
}

.show-more-button {
  width: 32px;
  height: 32px;
  padding: 0px;
  margin-left: -5px;
  display: flex;
  align-items: center;
  justify-content: center;
  text-align: center;
  border-radius: 96px;
  border: 2px solid #fff;
  background-color: #eee; /* Arka plan rengi */
  color: #333333;
  font-size: 12px;
  font-weight: 500;
  line-height: 18px;
  font-family: Roboto;
  text-transform: uppercase;

  i {
    font-size: 14px;
    color: #333333;
    margin-right: 0;
  }
}
.assignees-tooltip {
  opacity: 1 !important;

  &.bs-tooltip-right {
    ::v-deep .arrow {
      &::before {
        border: 0 !important;
        background: url('data:image/svg+xml,<svg xmlns="http://www.w3.org/2000/svg" width="17" height="9" viewBox="0 0 17 9" fill="none"><path d="M17 9L0 9L7.04598 1.53956C7.83522 0.703886 9.16478 0.703887 9.95403 1.53956L17 9Z" fill="%23DBF0F9"/><path fill-rule="evenodd" clip-rule="evenodd" d="M1.5 9L0 9L7.04598 1.53956C7.83522 0.703886 9.16478 0.703887 9.95403 1.53956L17 9L15.5 9L14.6801 8L9.22701 2.22618C8.83239 1.80835 8.16761 1.80835 7.77299 2.22618L2.31993 8L1.5 9Z" fill="%23B7E1F3"/></svg>');
        width: 17px;
        height: 9px;
      }
    }
  }

  &.bs-tooltip-left {
    ::v-deep .arrow {
      &::before {
        border: 0 !important;
        background: url('data:image/svg+xml,<svg xmlns="http://www.w3.org/2000/svg" width="17" height="9" viewBox="0 0 17 9" fill="none"><path d="M17 9L0 9L7.04598 1.53956C7.83522 0.703886 9.16478 0.703887 9.95403 1.53956L17 9Z" fill="%23DBF0F9"/><path fill-rule="evenodd" clip-rule="evenodd" d="M1.5 9L0 9L7.04598 1.53956C7.83522 0.703886 9.16478 0.703887 9.95403 1.53956L17 9L15.5 9L14.6801 8L9.22701 2.22618C8.83239 1.80835 8.16761 1.80835 7.77299 2.22618L2.31993 8L1.5 9Z" fill="%23B7E1F3"/></svg>');
        width: 17px;
        height: 9px;
        transform: rotate(180deg);
      }
    }
  }

  &.bs-tooltip-bottom {
    padding: 0 !important;
    top: 10px !important;

    ::v-deep .arrow {
      &::before {
        border: 0 !important;
        background: url('data:image/svg+xml,<svg xmlns="http://www.w3.org/2000/svg" width="17" height="9" viewBox="0 0 17 9" fill="none"><path d="M17 9L0 9L7.04598 1.53956C7.83522 0.703886 9.16478 0.703887 9.95403 1.53956L17 9Z" fill="white"/><path fill-rule="evenodd" clip-rule="evenodd" d="M1.5 9L0 9L7.04598 1.53956C7.83522 0.703886 9.16478 0.703887 9.95403 1.53956L17 9L15.5 9L14.6801 8L9.22701 2.22618C8.83239 1.80835 8.16761 1.80835 7.77299 2.22618L2.31993 8L1.5 9Z" fill="%23E5E5E5"/></svg>') !important;
        width: 17px;
        height: 9px;
        bottom: 5px;
      }
    }
  }

  ::v-deep .tooltip-inner {
    border: 1px solid var(--Stroke-Colors-Light-Blue-Stroke, #e5e5e5) !important;
    background: var(--Background-Colors-Light-Blue, #fff) !important;
    border-radius: 4px !important;
    padding: 8px 12px !important;
    width: fit-content !important;
    max-width: fit-content !important;
    box-shadow: 0px 2px 6px 0px rgba(176, 186, 197, 0.6) !important;

    text-align: left;
    color: var(--Text-Colors-Blue-Text, #333) !important;
    /* Typography/Small Text/1 - Regular */
    font-family: Roboto;
    font-size: 12px;
    font-style: normal;
    font-weight: 400;
    line-height: 18px; /* 150% */
  }
}
</style>
